<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="company">
        <div class="company-head">
          <div class="company-head-content">
            <span>圈子</span>
            <el-select v-model="property" @change="changepropertyId">
              <el-option v-for="item in propertyList" :key="item.id" :label="item.name" :value="item.id" v-if="item.isJoin">
              </el-option>
            </el-select>
            <span>行业</span>
            <el-select v-model="industry" @change="changeindustryId" clearable>
              <el-option v-for="item in industryList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <span>大区</span>
            <el-select v-model="region" @change="changeregionId" clearable>
              <el-option v-for="item in regionList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <span>企业名称</span>
            <el-input v-model="company_name"></el-input>
            <el-button type="primary" round @click="search()" class="search">查询</el-button>
          </div>
        </div>
        <div class="company-content" v-for="(item, i) in companyItems" :key="i" v-if="companyItems.length">
          <div class="company-content-left">
            <viewer><img v-if="item.pic1" :src="imgUrl + item.pic1" class="leftimage" alt="" />
              <img v-else :src="basehead" class="leftimage" alt="" /></viewer>

          </div>
          <div class="company-content-right">
            <div class="company-content-right-top">
              <div class="title" @click="showtag(i)">{{ item.name }}</div>
              <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}">
                <div class="head_picture">
                  <img class="headpicture" v-if="item.pic" :src="imgUrl + item.pic" alt="" />
                  <img class="headpicture" v-else :src="baseUrl" alt="" />
                  <span class="headpicturename">{{item.appUserName}}</span>
                </div>
              </router-link>
            </div>
            <div class="industry" @click="showtag(i)">
              行业：<el-tag v-for="(item1, i) in item.appuserIndustryList" :key="i">{{item1.name }}</el-tag>

            </div>

            <div class="property" @click="showtag(i)">
              大区：<el-tag v-for="(item2, i) in item.appuserRegionList" :key="i">
                {{item2.name}}</el-tag>

            </div>

            <div id="companyintroduction" @click="showtag(i)">公司介绍</div>
            <br />
            <div class="introduction" @click="showtag(i)">
              {{ item.memo }}
            </div>
          </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="50%" append-to-body>
          <span v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow" class="phone" slot="title">{{ item.appUserName }}</span>
          <span v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow" class="phone"><span class="companyname">{{item.name}}</span>联系方式：{{item.tel}}</span>
          <div class="showtitle">{{propertyname }}</div>
          <div class="showtitle">行业</div>
          <div v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow">
            <el-tag v-for="(item1, i) in item.appuserIndustryList" :key="i">{{item1.name }}
            </el-tag>
          </div>
          <div>
            <div class="showtitle">大区</div>
            <div v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow">
              <el-tag v-for="(item1, i) in item.appuserRegionList" :key="i">{{item1.name }}
              </el-tag>
            </div>

          </div>
          <div class="showtitle">公司介绍</div>
          <div v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow">
            <span class="memo">{{ item.memo}}</span>

          </div>
         <img v-viewer :src="imgUrl + item.pic1" v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow&&item.pic1" class="companyimg">
            <img v-viewer :src="imgUrl + item.pic2" v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow&&item.pic2" class="companyimg">
            <img v-viewer :src="imgUrl + item.pic3" v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow&&item.pic3" class="companyimg">
            <img v-viewer :src="imgUrl + item.pic4" v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow&&item.pic4" class="companyimg">
            <img v-viewer :src="imgUrl + item.pic5" v-for="(item, index) in companyItems" :key="index" v-if="index === indexshow&&item.pic5" class="companyimg">

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>

        <div class="company-no" v-if="!total">暂无企业信息</div>
           <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
       :page-sizes="[10]"
      :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      </div>
    </div>
  </div>
</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
const companyItems = []
const totalItems = []
import {
  propertyList
} from "../api/api";
import {
  industryList
} from "../api/api";
import {
  regionList
} from "../api/api";
import {
  userCompanyList
} from "../api/api"
import {
  token,
  getpropertylist,
  listSearchHistory
} from "../api/api"
import transparentheaders from "../components/transparentheaders.vue";
export default {
  data() {
    return {
      totalItems,
      companyItems,
      property: "",
      region: "",
      industry: "",
      company_name: "",
      propertyList: [], //圈子列表
      industryList: [], //行业列表
      regionList: [], //大区列表
      userid: "", //用户编号
      propertyId: "", //圈子编号
      industryid: "", //行业编号
      regionid: "", //大区编号
      imgUrl,
      basehead: require("../assets/images/background_company_second.png"),
      baseUrl: require("../assets/images/mycenterheadpicture.png"),
      propertyname: "",
      dialogVisible: false,
      indexshow: "",
      currentPage: 1,
      msg:"",
      total:""
    };
  },
  components: {
    transparentheaders
  },
  created() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
     this.propertyId = JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
    this.getuserCompanyList();
    getpropertylist({
        userId: this.userid,
        pageNo: 1,
      }).then(res => {
        if (res.data.code == 200) {
          this.propertyList = res.data.result.records;
           this.propertyname = res.data.result.records[0].name
          this.propertyId = res.data.result.records[0].id
          this.property = res.data.result.records[0].id
          
          this.getindustryList();
          this.getregionList();
         
        }
      });
  },
  mounted() {
    
    
    
  },
  methods: {
    backtop() {



  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

    },
    gettoken() {
      token({}).then(res => {
        if (res.data.code == 200) {

          console.log(res.data.result);
        }
      });
    },
   handleSizeChange(val) {
      this.pagesize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      userCompanyList({

        userId: this.userid,
        propertyId: this.propertyId,
        industry: this.industryid,
        region: this.regionid,
        name: "",
        pageNo: this.currentPage,
        pageSize: 10,
      }).then(res => {
        if (res.data.code == 200) {
          this.companyItems = res.data.result.records;
        }
      });
      this.backtop();
    },
    getuserCompanyList() {
     
      userCompanyList({

        userId: this.userid,
        propertyId: this.propertyId,
        industry: this.industryid,
        region: this.regionid,
        name: "",
        pageNo: 1,
        pageSize: 10,
      }).then(res => {
        if (res.data.code == 200) {
          this.companyItems = res.data.result.records;
          this.total = res.data.result.total
         
          // for (let i = 0; i < this.companyItems.length; i++) {
          //   for (let j = 0; j < this.companyItems[i].length; j++) {
          //     console.log(this.companyItems[j].appuserIndustryList)
          //   }
          // }
        }
      });
       
    },
    getindustryList() {
      industryList({
        userId: this.userid,
        propertyId: this.propertyId
      }).then(res => {
        if (res.data.code == 200) {
          this.industryList = res.data.result;
        }
      });
    },
    getregionList() {
      regionList({
        userId: this.userid,
        propertyId: this.propertyId
      }).then(res => {
        if (res.data.code == 200) {
          this.regionList = res.data.result;
        }
      });
    },
    changepropertyId(e) {
      this.propertyId = e;
      this.regionid = ""
      this.industryid = ""
      this.industry = ""
      this.region = ""
      this.getindustryList();
      this.getregionList();
      this.getuserCompanyList();
     

    },
    changeindustryId(e) {
      this.industryid = e;
      this.getuserCompanyList()

    },
    changeregionId(e) {
      this.regionid = e;
      this.getuserCompanyList()
    },
    search() {
      this.listsearch();
      let data = {
        appuserId: this.userid,
        name: this.company_name,
      };
      // addSearchHistory(data).then(res => {
      //   if (res.data.code == 200) {
      //     console.log(res.data);
      //   }
      // });
      userCompanyList({

        userId: this.userid,
        propertyId: this.propertyId,
        industry: this.industryid,
        region: this.regionid,
        name: this.company_name,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          this.companyItems = res.data.result.records
           this.total = res.data.result.total
        }
      });
      listSearchHistory({
        userId: this.userid,
      }).then(res => {
        if (res.data.code == 200) {

        }
      });

    },
    listsearch() {
      listSearchHistory({
        userId: this.userid,
      }).then(res => {
        if (res.data.code == 200) {

        }
      });
    },
    showtag(e) {
      this.dialogVisible = true
      this.indexshow = e;

    },

  }
};
</script>

<style lang="scss" scoped>
.company {
  margin-top: 70px;
  display: flex;
  flex-direction: column;

}

.company-head {
  background: white;
  height: 120px;
  margin-bottom: 15px;
  position: relative;
}

.company-content {
  background: white;
  // flex-grow: 0.6;
  display: flex;
  padding: 10px;
  margin-bottom: 15px;

  height: 420px;
  position: relative;
}

.company-no {
  background: white;
  // flex-grow: 0.6;

  padding: 10px;
  text-align: center;
  height: 90vh;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  min-height: 100vh;
}

.white {
  background: white;
}

.el-input {
  width: 222px;
  height: 50px;
}

span {
  margin-right: 10px;
}

.el-select {
  width: 180px;
  height: 50px;
  margin-right: 20px;
}

>>>.el-input__inner {
  border-radius: 8px;
}

.search {
  margin-left: 10px;
  border-radius: 21px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "SourceHanSsansCN";
}

>>>.el-button.is-round {
  padding: 12px 24px;
  letter-spacing: 3px;
}

>>>.el-icon-arrow-up:before {
  margin-left: 10px;
  content: url(../assets/images/arrow.png);
}

.leftimage {
  margin-top: 52px;
  margin-left: 44px;
  width: 266px;
  height: 266px;
  border-radius: 15px;
}

.company-content-right-top {
  display: flex;
}

.company-head-content {
  margin-top: 37px;
  margin-left: 54px;
}

.company-content-right {
  margin-top: 58px;
  margin-left: 40px;
}

.title {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  margin-bottom: 20px;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 550px;
}

.headpicturename {
  font-size: 14px;
  font-family: "SourceHanSansSC";
  color: rgb(102, 102, 102);
  padding: 10px;
  text-align: right;
}

.head_picture {
  position: absolute;
  top: 14%;
  right: 3%;
}

.introduction {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(152, 152, 152);
  line-height: 1.714;
  text-align: justifyLeft;
  margin-top: -10px;
  margin-right: 80px;

  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;

}

#companyintroduction {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  margin-top: 26px;

}

.industry {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  line-height: 1.714;
  text-align: justifyLeft;
  margin-bottom: 10px;
  width: 700px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;

}

.property {
  cursor: pointer;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  line-height: 1.714;
  text-align: justifyLeft;
  width: 700px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;

}

.el-tag {
  border-radius: 15px;
  border-color: rgb(241, 241, 241);
  background: rgb(250, 250, 250);
  text-align: center;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(102, 102, 102);

  padding: 0px 15px 10px 15px;
  margin-bottom: 10px;
  cursor: pointer;
}

.el-tag:hover {
  background: rgb(10, 108, 255);
}

.headpicture {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.showtitle {
  font-size: 16px;
  padding-bottom: 15px;
  padding-top: 20px
}

.phone {
  font-size: 16px;
  font-weight: 700;
  color: black;
}

>>>.el-dialog__body {
  padding: 20px;
  color: black;
}

.companyname {
  margin-right: 20px;
}

.memo {
  font-size: 14px;
  color: #989898;
  white-space: pre-wrap;
  word-break: break-all;
}

.companyimg {
  width: 900px;
  height: 400px;
  margin-top: 30px;
  object-fit: contain
}
.el-pagination {
    
    text-align: center
}
</style>



// WEBPACK FOOTER //
// src/components/job.vue